// import config from '@plone/volto/registry';

export function getAllowedBlocks(type) {
  return ['image', 'text'];
}
